import { buttonRecipe } from './buttonrecipe';

export const recipes = {
  button: buttonRecipe,
  //   Input,
  //   Table,
  //   Card,
  //   Heading,
  //   Text,
  //   Drawer,
};
